export const ROUTES_LOCALES = {
   'en-US': {
		routes: {
			404: '404',
			home: 'home',
			crm: 'crm',
			edm: 'edm',
			associations: 'associations',
			mobile: 'mls-touch',
			contact: 'contact-us',
			about: 'about-us',
			news: 'news',
			news1: 'launch-advanced-integrations',
			news2: 'hicentral-selects-mlstouch',
			news3: 'heartland-selects-mlstouch',
			blog: 'blog',
			blog1: 'should-themls-offer-crm',
			careers: 'careers',
			privacy: 'privacy-policy',
			terms: 'terms-conditions',

		}
	},
   'en-CA': {
		routes: {
			404: '404',
			home: 'home',
			crm: 'crm',
			edm: 'edm',
			associations: 'associations',
			mobile: 'mobile-android-ios',
			contact: 'contact-us',
			about: 'about-us',
			news: 'news',
			news1: 'launch-advanced-integrations',
			news2: 'hicentral-selects-mlstouch',
			news3: 'heartland-selects-mlstouch',
			blog: 'blog',
			blog1: 'should-themls-offer-crm',
			careers: 'careers',
			privacy: 'privacy-policy',
			terms: 'terms-conditions',
		}
	},
   'fr-CA': {
		routes: {
			404: '404',
			home: 'accueil',
			crm: 'crm',
			edm: 'ged',
			associations: 'associations',
			mobile: 'mobile-android-ios',
			contact: 'nous-contacter',
			about: 'a-propos',
			news: 'nouvelles',
			news1: 'launch-advanced-integrations',
			news2: 'hicentral-selects-mlstouch',
			news3: 'heartland-selects-mlstouch',
			blog: 'blog',
			blog1: 'should-themls-offer-crm',
			careers: 'carrieres',
			privacy: 'politique-confidentialite',
			terms: 'conditions-utilisation',
		}
   }
};

export const ROUTES = [ ...localizedRoutesHelper() ];

function localizedRoutesHelper() {
   return Object.entries(Object.values(ROUTES_LOCALES)[0].routes).map(([componentName, defaultLocalePath]) => {
		var path = buildPath(defaultLocalePath);
		return {
			path,
			name: componentName,
			alias: ["/" + defaultLocalePath].concat(Object.keys(ROUTES_LOCALES)
				.map(locale => buildPath(ROUTES_LOCALES[locale].routes[componentName]))
				.filter((alias, position, aliases) => aliases.indexOf(alias) == position && alias != path)),
			component: () => import('@/components/pages/' + capitalizeFirstChar(componentName) + '.vue')
		};
	}).concat([{ path: '/' }, { path: '*', redirect: { name: '404' } }]);
}

function capitalizeFirstChar(string) {
	return string.charAt(0).toUpperCase() + string.slice(1);
}

function buildPath (path) {
	return '/:language/:region/' + path;
}